import React from "react";
import { Call, ProfileUser, MailFill } from "sushiweb/Icons";
import { Link } from "react-router-dom";
import { getPath } from "../../utils/index";
import styled from "styled-components";
import { UserTypes } from "../../constants/OrderPayout/utils";

const OrderBasicDetailCard = (props) => {
  const { data, type } = props;
  if (!data) {
    return <p> {type} Details doesn't exist</p>;
  }
  return (
    <UserDetailCardWrapper type={type}>
      {data.map((info) => {
        if (info.link.length) {
          return (
            <a href={info.link} target={"_blank"}>
              {info.value}
            </a>
          );
        } else {
          return <p>{info.value}</p>;
        }
      })}
    </UserDetailCardWrapper>
  );
};

export default OrderBasicDetailCard;

const UserDetailCardWrapper = styled.div`
  width: 25%;
  text-align: ${(props) =>
    props.type === UserTypes.Merchant ? "right" : "left"};
  padding: 20px;
  a,
  p {
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
